import React from 'react';
import styles from './Hero.module.css';
import mapIcon from '../../images/maps-and-flags.png';
import 'bootstrap/dist/css/bootstrap.min.css';

const DevIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#9a9a9a">
    <text x="1" y="17" fontSize="13" fontFamily="monospace" fontWeight="bold">&lt;/&gt;</text>
  </svg>
);

const Hero = ({ hideLocationInfo = false }) => {
  return (
    <div className={`d-flex flex-column justify-content-center align-items-center w-100 mb-5 position-relative ${styles.heroTextWrapper}`}> 
      <h1 className={`text-center ${styles.blackGradientH1}`}>hi, i'm marco</h1>
      <div className="d-flex align-items-center justify-content-center mb-3">
        <img src={mapIcon}
              width={24}
              height={24}
              alt="Location Icon"
              className={`${styles.locationIcon} ${styles.grayIcon}`}
        />
        <div className={`fw-bold ms-2 text-center ${styles.locationGradient}`}>minden, germany</div>
      </div>
      <div className={`text-center ${styles.heroParagraph}`}>
        <p className={`${styles.heroParagraphText}`}>
        currently working at
        <a href="https://www.harting.com/" target="_blank" rel="noopener noreferrer" className={`ms-2 me-2 ${styles.linkText}`}>
             Harting Technology Group
        </a><br></br>
          as an Application Developer with focus on JavaScript and .Net
        </p>
      </div>
    </div>
  );
};

export default Hero; 